import {
  trackingGroupLeaveRequest,
  trackingGroupDeleteRequest,
  trackingSearchRequest,
} from './handlers';

export const RequestTracker = (operation: any) => {
  switch (operation.operationName) {
    case 'getSearchFeed':
      trackingSearchRequest(operation);
      break;

    case 'leaveGroup':
      trackingGroupLeaveRequest(operation);
      break;

    case 'deleteGroup':
      trackingGroupDeleteRequest(operation);
      break;

    default:
      break;
  }
};
